import { render } from "./number-grow.vue?vue&type=template&id=11e928e3"
import script from "./number-grow.vue?vue&type=script&lang=js"
export * from "./number-grow.vue?vue&type=script&lang=js"

import "./number-grow.vue?vue&type=style&index=0&id=11e928e3&lang=scss"
script.render = render

export default script